import { render, staticRenderFns } from "./ShiftTable.vue?vue&type=template&id=2b072e8a&scoped=true"
import script from "./ShiftTable.vue?vue&type=script&lang=js"
export * from "./ShiftTable.vue?vue&type=script&lang=js"
import style0 from "./ShiftTable.vue?vue&type=style&index=0&id=2b072e8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b072e8a",
  null
  
)

export default component.exports